export class ReviewCommissionsModel {
    public commPlanId: number;
    public commissionPlanId: number[] = [];
    public salesChannel: string;
    public country: string;
    public commPlan: string;
    public calendarType: string;
    public validToDt: Date;
    public validFromDt: Date;
    public payDate: Date;
    public calRunId: string;
    public effectiveDate: Date;
    public isSalesRepAccess: string;

    public firstName: string;
    public lastName: string;
    public employeeId: string;
    public dependentScempid: string
    public scEmpID: string;
    public sales_rep_id: string;
    public salesRepId: string;

    public pageName: string;
    public userRole: string;
    public user_role: string;
    public user_type: string;

    public comm_plan_id: number;
    public cal_run_id: string;
    public sc_emp_id: string;

    public kpi_id: number;
    public dependentKpiId: number;
    public dpndnt_kpi_id: number;
    public selectedPageName: string;
    public selectedGridName: string;
    public queryIdx: string;

    public corp: number;
    public house: string;
    public cust: string;
    public account_number: number;
    public subscriber_number: number;
    public kom_feed_id: any;
    public mob_feed_id: any;

    public grid_name: string;
    public isDisputeSubmitted: string;
    public finalConfigId: string;
    public calcRunStatus: string;
    public disputeCloseDateStatus: string;

    public selectedCommPlanHeader: string;
    public display_name: string;
    public cust_name: string;

    public loggedInEmpId: string;
    public teamDataCheckedactive: boolean = false;

    
    // Commission Report Approval fields
    public sendToEmployeeId: string;
    public createdBy: string;
    public loggedinRole: string;
    public effectiveDateFrom: string;
    public payrollMonth: string;
    public message: string;
    public totalCommission: number;
    /** Frozen report the admin saw at send time (pivoted rows + KPI layout). */
    public reportSnapshot: {
        version: number;
        payrollMonth: string;
        grandTotalCommission: number;
        visibleKpiConfigs: any[];
        configsByPlan: Record<number, any[]>;
        pivotedData: any[];
    };

    constructor() {
        this.salesRepId = null;
        this.loggedInEmpId = null;
        this.account_number = null;
        this.subscriber_number = null;
        this.kom_feed_id = null;
        this.mob_feed_id = null;
        this.cust_name = null;
        this.display_name = null;
        this.selectedCommPlanHeader = null;
        this.disputeCloseDateStatus = null;
        this.calcRunStatus = null;
        this.finalConfigId = null;
        this.queryIdx = null;
        this.isDisputeSubmitted = null;
        this.dependentScempid = null;
        this.grid_name = null;
        this.corp = null;
        this.house = null;
        this.cust = null;
        this.selectedPageName = null;
        this.selectedGridName = null;
        this.kpi_id = null;
        this.dependentKpiId = null;
        this.dpndnt_kpi_id = null;
        this.comm_plan_id = null;
        this.cal_run_id = null;
        this.sc_emp_id = null;
        this.pageName = null;
        this.userRole = null;
        this.user_role = null;
        this.user_type = null;
        this.firstName = null;
        this.lastName = null;
        this.employeeId = null;
        this.scEmpID = null;
        this.sales_rep_id = null;
        this.commPlanId = null;
        this.salesChannel = null;
        this.country = null;
        this.commPlan = null;
        this.calendarType = null;
        this.validToDt = null;
        this.validFromDt = null;
        this.payDate = null;
        this.calRunId = null;
        this.effectiveDate = null;
        this.isSalesRepAccess = null;
        this.sendToEmployeeId = null;
        this.createdBy = null;
        this.loggedinRole = null;
        this.effectiveDateFrom = null;
        this.payrollMonth = null;
        this.message = null;
        this.totalCommission = null;
        this.reportSnapshot = null;
    }
}
